import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react'
import { Badge } from '@sitecore-ui/design-system'
import type { Component } from '@sitecore-feaas/api'

interface Props {
  status: Component['status']
}

const StatusBadge: FunctionComponent<Props> = (props: Props): ReactElement | null => {
  const { status } = props

  const [colorScheme, setColorScheme] = useState<string>('')

  useEffect(() => {
    switch (status) {
      case 'published':
        setColorScheme('green')
        break
      case 'staged':
        setColorScheme('cyan')
        break
      case 'deleted':
        setColorScheme('red')
        break
      case 'draft':
        setColorScheme('blue')
        break
      case 'changed':
        setColorScheme('yellow')
        break
    }
  }, [status])

  return colorScheme && <Badge colorScheme={colorScheme}>{status}</Badge>
}

export default StatusBadge
